<template>
    <crud-create :open="open"
                 :loading="loading"
                 :title="title"
                 :errorMessage="errorMessage"
                 @create="save"
                 @close="$emit('close')"
    >

           <Invira-roles-form ref="form" v-model="form" :input-errors="inputErrors"></Invira-roles-form>

    </crud-create>
</template>

<script>
    import InviraRoleProvider from "../../../providers/InviraRoleProvider";
    import { CrudCreate } from '@dracul/common-frontend'
    import { ClientError } from "../../../../../errors";
    import InviraRolesForm from '../InviraRolesForm'

    export default {
        name: "InviraRolesCreate",
        components: {CrudCreate, InviraRolesForm},
        props: {
            open: {type: Boolean, default: true}
        },
        data() {
            return {
                title: "admin.inviraRole.creating",
                errorMessage: "",
                inputErrors: {},
                loading: false,
                form: {
                    name: null,
                    childRoles: null,
                    permissions: [],
                    companyId: null
                }

            };
        },

        methods: {
            save() {
                if (this.$refs.form.validate()) {
                    this.loading = true
                    InviraRoleProvider.roleCreate(this.form)
                        .then(r => {
                            if (r) {
                                this.$emit("roleCreated", r.data.adminInviraRoleCreate)
                                this.$emit("close")
                            }
                        })
                        .catch(error => {
                            let clientError = new ClientError(error);
                            this.inputErrors = clientError.inputErrors
                            this.errorMessage = clientError.i18nMessage
                        }).finally(() => this.loading = false)
                }
            },
        }
    };
</script>

